<div class="playlistWrapper" (click)="onShowDetails()">
  <!--<tun-star-icon-v5 *ngIf="isFavorite" class="icon icon-scaled-svg-button favoriteIcon"></tun-star-icon-v5>-->
  @if (isFavorite) {
    <tun-thumb-up-icon-v5 class="icon icon-scaled-svg-button favoriteIcon"></tun-thumb-up-icon-v5>
  }
  <div class="playlistTitleContainer">
    <tun-scrollable-text class="playlistTitle" [text]="playlist.title"></tun-scrollable-text>
  </div>
</div>
